var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-player-popup c-player-popup--dark"},[_c('div',{staticClass:"c-player-popup__container"},[_c('div',{staticClass:"o-icon o-icon--hide-pass o-icon--xlarge"}),_c('div',{staticClass:"o-typography__headline4"},[_vm._v(" "+_vm._s(_vm.$t('player.catchupUnavailable'))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }